import { ModalConfirmation, notify, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useDisableNemhandel } from '@features/eInvoicingSettings/hooks/useDisableNemHandel'

import { ModalId } from '../../../../enums/modalId'
import { NotificationKeys } from '../../../../enums/notificationKeys'
import { DisableEInvoicingModalMessage } from '../EInvoicingDisableModalMessage'

export const NemHandelDisableModal = (): ReactElement => {
  const { t } = useTranslation()
  const { close } = useModal(ModalId.DisableEInvoicingModal)
  const { disableNemhandel, isProcessing } = useDisableNemhandel()

  const handleDisable = useCallback(async () => {
    try {
      await disableNemhandel()
      notify({
        id: NotificationKeys.EInvoiceDisablingSuccessful,
        message: t('disable_e_invoicing.notify.success'),
        variant: 'success',
      })
      close()
    } catch {
      notify({
        id: NotificationKeys.EInvoiceDisablingError,
        message: t('disable_e_invoicing.notify.error'),
        variant: 'error',
      })
      close()
    }
  }, [disableNemhandel, close, t])

  return (
    <ModalConfirmation
      cancelLabel={t('cancel')}
      danger
      id={ModalId.DisableEInvoicingModal}
      okLoading={isProcessing}
      message={<DisableEInvoicingModalMessage />}
      okLabel={t('receipts.side_panel.e_invoice_reception.deactivate')}
      onOk={handleDisable}
      title={t('disable_e_invoicing_modal.title')}
    />
  )
}
